export default "__VITE_ASSET__69d25dac__"